<template lang="pug">
  DrawerContents
    template(#top)
      Message(status="success" v-if="state === 'success'") {{__('Registry updated.')}}
    radio(
      v-for="list in displayedRegistries"
      :key="list._id"
      :disabled="state === 'success'"
      :option="list._id"
      v-model="listId"
      name="registry"
      :label="list.metadata.registry.name"
    )
    radio(label="Add To New Registry" v-if="state !== 'success'" option="new" v-model="listId" name="registry")
    create-registry.create(v-if="listId === 'new'" @save="listId = $event._id" :embedded="true")

    template(#bottom)
      template(v-if="listId !== 'new'")
        RogueButton(
          v-if="state !== 'success'"
          @click="add()"
          :disabled="!listId"
          :loading="state === 'loading'"
          color="red"
          width="full"
        ) {{__('Confirm Registry Selection')}}
        .pad(v-else)
          .flex
            RogueButton.goTo(:link="'/account/registry/'+listId" color="red") {{__('Go to Registry')}}
            RogueButton.done(@click="$emit('hide')") {{__('Done')}}
</template>
<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useListStore } from '@/js/stores/listStore'
import { useRogue } from '@/js/services/Rogue'
import CreateRegistry from './create-registry.vue'
import type { BuyRequest } from '@/js/services/RogueTypes'


const props = defineProps<{
  buyRequest: BuyRequest
}>()

const emit = defineEmits(['hide'])

const listStore = useListStore()
const rogue = useRogue()

const listId = ref('')
const state = ref<string | null>(null)

const registries = computed(() => listStore.registries)
const displayedRegistries = computed(() => 
  registries.value.filter(list => list.metadata?.registry)
)

const add = async () => {
  state.value = 'loading'
  
  const requests = Array.isArray(props.buyRequest) ? [...props.buyRequest] : [props.buyRequest]

  requests.forEach(req => {
    req.metadata = req.metadata || {}
    req.metadata.registry = req.metadata.registry || { priority: 'medium' }
    
    if (req.type === 'grouped' && req.children) {
      req.children.forEach((child: any) => {
        child.metadata = child.metadata || {}
        child.metadata.registry = { priority: 'medium' }
      })
    }
  })

  await listStore.addListItems(rogue, listId.value, requests)
  
  setTimeout(() => {
    state.value = 'success'
  }, 500)
}

onMounted(() => {
  listId.value = displayedRegistries.value[0]?._id || 'new'
})
</script>
<style lang="scss" scoped>
.radio-container {
  border: none;
  line-height: 64px;
}

.message {
  margin-bottom: $space-s;
}

.flex {
  display: flex;
  width: 100%;
}

.goTo {
  flex-grow: 2;
}

.create {
  margin-top: $space-s;
}

.done {
  flex-grow: 1;
  margin-left: $space-s;
}

</style>
